"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("./styles");
var eventNames_1 = require("./eventNames");
var specialCases_1 = require("./specialCases");
/**
 * Parse set of jsx attributes to dom attributes, properties, events and special keys
 */
function parseAttributesObject(attributesObj) {
    var events = {};
    if (!attributesObj) {
        return { events: events };
    }
    var attributes = [];
    var key = null;
    var ref;
    var innerHTML;
    var childNodes;
    var skipChildren;
    Object.keys(attributesObj).forEach(function (attributeName) {
        var value = attributesObj[attributeName];
        var lcAttributeName = attributeName.toLowerCase();
        if (value === false) {
            value = undefined;
        }
        else if (value === true) {
            value = '';
        }
        if (lcAttributeName === 'childnodes') {
            // childnodes will be set separately
            childNodes = value;
        }
        else if (lcAttributeName === 'dangerouslysetinnerhtml') {
            // innerHTML in React form
            innerHTML = value.__html;
        }
        else if (lcAttributeName === 'innerhtml') {
            // regular innerHTML
            innerHTML = value;
        }
        else if (attributeName === 'key') {
            // key attribute is used by incremental-dom
            key = value;
        }
        else if (attributeName === 'ref') {
            // ref is used for referencing children
            ref = value;
        }
        else if (attributeName.indexOf('on') === 0) {
            // events
            if (typeof value === 'string') {
                attributes.push(attributeName, value);
            }
            else {
                var _a = eventNames_1.normalizeEventName(attributeName), name_1 = _a.name, capture = _a.capture;
                events[name_1] = { listener: value, capture: capture };
            }
        }
        else if (lcAttributeName === 'skipchildren') {
            skipChildren = attributesObj[attributeName];
        }
        else {
            if (specialCases_1.specialCases(lcAttributeName)) {
                attributeName = specialCases_1.specialCases(lcAttributeName);
            }
            else if (attributeName === 'style') {
                value = styles_1.parseStyles(value);
            }
            else if (lcAttributeName !== attributeName) {
                if (typeof value === 'undefined' || typeof value === 'number' || typeof value === 'string') {
                    // for primitives if name is camelCase we will change the name to dashCase
                    attributeName = camelToDash(attributeName);
                }
            }
            attributes.push(attributeName, value);
        }
    });
    return { attributes: attributes, key: key, ref: ref, innerHTML: innerHTML, events: events, childNodes: childNodes, skipChildren: skipChildren };
}
exports.parseAttributesObject = parseAttributesObject;
/**
 * camelCase to dash-case transform
 */
function camelToDash(str) {
    return str.replace(/([A-Z])/g, function (g) { return '-' + g[0].toLowerCase(); });
}
